"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useVisibilityState = void 0;
const useToolsStateSelector_1 = require("./useToolsStateSelector");
function useVisibilityState() {
    return (0, useToolsStateSelector_1.useToolsStateSelector)(state => ({
        hideAnnotations: state === null || state === void 0 ? void 0 : state.hideAnnotations,
        hideLabels: (state === null || state === void 0 ? void 0 : state.hideLabels) === null ? true : state === null || state === void 0 ? void 0 : state.hideLabels,
    }));
}
exports.useVisibilityState = useVisibilityState;
